import StatusChangeList from './status_change_list'
import connect from './connect'

export default connect(StatusChangeList)
